import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import '@mui/styles';

import { addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
import LoopbackProvider from './loopback/LoopbackProvider';
import configureStore from './redux/configureStore';
import { muiTheme } from './styles/componentStyles';
import { setLanguage } from './redux/actions';
import { getGlobalBaseName, mapDOMLocaleToReactIntl } from './core/cmsIntegration';
import { BACKEND_URL } from './environment';

import './index.css';
import './styles/utility.css';
import './styles/globals.css';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

LoopbackProvider.loopbackHost = BACKEND_URL;

const store = configureStore();
store.dispatch(setLanguage(mapDOMLocaleToReactIntl()));
LoopbackProvider.store = store;
addLocaleData([...de]);

type Props = {
  children: React.ReactNode;
}
const Root: React.FC<Props> = ({ children }: Props) => (
  <Provider store={store}>
    <IntlProvider>
      <BrowserRouter basename={getGlobalBaseName()}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={muiTheme}>
            {children}
          </ThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </IntlProvider>
  </Provider>
);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export default Root;
